// extracted by mini-css-extract-plugin
module.exports = {"label":"FiltersBadge_label__15Pns","root":"FiltersBadge_root__1udXY","checkbox":"FiltersBadge_checkbox__2CXq3"};